import React, { useState } from 'react'
import NavBar from '../component/NavBar'

function Donate() {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    address: '',
    city: '',
    country: '',
    postalCode: '',
    donationAmount: '',
    customAmount: '',
    paymentMethod: '',
    cardName: '',
    cardNumber: '',
    expiryDate: '',
    cvv: ''
  })

  const [isMonthly, setIsMonthly] = useState(false)

  const donationAmounts = [25, 50, 100, 250, 500, 1000]

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({
      ...prev,
      [name]: value
    }))
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    // Handle donation submission
    console.log('Donation submitted:', formData)
    alert('Thank you for your generous donation! We will process it shortly.')
    setFormData({
      firstName: '',
      lastName: '',
      email: '',
      phone: '',
      address: '',
      city: '',
      country: '',
      postalCode: '',
      donationAmount: '',
      customAmount: '',
      paymentMethod: '',
      cardName: '',
      cardNumber: '',
      expiryDate: '',
      cvv: ''
    })
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <NavBar />

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-gray-800 to-gray-900 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">
            Donate to Shehala Foundation
          </h1>
          <p className="text-xl opacity-90 max-w-2xl mx-auto">
            Your generosity makes a huge difference in our mission to provide healthcare, education, and support to those in need.
          </p>
        </div>
      </section>

      {/* Donation Form Section */}
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold text-center text-gray-800 mb-4">
              Make a Difference Today
            </h2>
            <p className="text-gray-600 text-center mb-8">
              Fill out the form below to make your donation securely.
            </p>

            <form onSubmit={handleSubmit} className="bg-gray-50 p-8 rounded-xl shadow-lg">
              {/* Donation Type Toggle */}
              <div className="flex justify-center gap-4 mb-8">
                <button
                  type="button"
                  onClick={() => setIsMonthly(false)}
                  className={`px-6 py-3 rounded-lg font-semibold transition duration-300 ${
                    !isMonthly
                      ? 'bg-gray-800 text-white'
                      : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100'
                  }`}
                >
                  One-time Donation
                </button>
                <button
                  type="button"
                  onClick={() => setIsMonthly(true)}
                  className={`px-6 py-3 rounded-lg font-semibold transition duration-300 ${
                    isMonthly
                      ? 'bg-gray-800 text-white'
                      : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100'
                  }`}
                >
                  Monthly Donation
                </button>
              </div>

              {/* Donation Amount */}
              <div className="mb-8">
                <label className="block text-gray-700 font-medium mb-3">Select Donation Amount</label>
                <div className="grid grid-cols-2 md:grid-cols-6 gap-3 mb-4">
                  {donationAmounts.map(amount => (
                    <button
                      key={amount}
                      type="button"
                      onClick={() => setFormData(prev => ({ ...prev, donationAmount: amount.toString(), customAmount: '' }))}
                      className={`py-3 rounded-lg font-semibold transition duration-300 ${
                        formData.donationAmount === amount.toString() && !formData.customAmount
                          ? 'bg-gray-800 text-white'
                          : 'bg-white text-gray-700 border border-gray-300 hover:bg-gray-100'
                      }`}
                    >
                      ${amount}
                    </button>
                  ))}
                </div>
                <div className="flex items-center gap-3">
                  <span className="text-gray-600 font-medium">$</span>
                  <input
                    type="number"
                    name="customAmount"
                    value={formData.customAmount}
                    onChange={handleChange}
                    placeholder="Enter custom amount"
                    className="flex-1 px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                  />
                </div>
              </div>

              {/* Personal Information */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b">Personal Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label htmlFor="firstName" className="block text-gray-700 font-medium mb-2">First Name *</label>
                    <input
                      type="text"
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                      placeholder="John"
                    />
                  </div>
                  <div>
                    <label htmlFor="lastName" className="block text-gray-700 font-medium mb-2">Last Name *</label>
                    <input
                      type="text"
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                      placeholder="Doe"
                    />
                  </div>
                  <div>
                    <label htmlFor="email" className="block text-gray-700 font-medium mb-2">Email Address *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      required
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                      placeholder="john@example.com"
                    />
                  </div>
                  <div>
                    <label htmlFor="phone" className="block text-gray-700 font-medium mb-2">Phone Number</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                      placeholder="+1 234 567 8900"
                    />
                  </div>
                  <div className="md:col-span-2">
                    <label htmlFor="address" className="block text-gray-700 font-medium mb-2">Address</label>
                    <input
                      type="text"
                      id="address"
                      name="address"
                      value={formData.address}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                      placeholder="123 Main Street"
                    />
                  </div>
                  <div>
                    <label htmlFor="city" className="block text-gray-700 font-medium mb-2">City</label>
                    <input
                      type="text"
                      id="city"
                      name="city"
                      value={formData.city}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                      placeholder="New York"
                    />
                  </div>
                  <div>
                    <label htmlFor="country" className="block text-gray-700 font-medium mb-2">Country</label>
                    <select
                      id="country"
                      name="country"
                      value={formData.country}
                      onChange={handleChange}
                      className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                    >
                      <option value="">Select country</option>
                      <option value="US">United States</option>
                      <option value="UK">United Kingdom</option>
                      <option value="CA">Canada</option>
                      <option value="AU">Australia</option>
                      <option value="BD">Bangladesh</option>
                      <option value="IN">India</option>
                      <option value="DE">Germany</option>
                      <option value="FR">France</option>
                      <option value="other">Other</option>
                    </select>
                  </div>
                </div>
              </div>

              {/* Payment Method */}
              <div className="mb-8">
                <h3 className="text-xl font-semibold text-gray-800 mb-4 pb-2 border-b">Payment Information</h3>
                
                {/* Payment Method Selection */}
                <div className="flex gap-4 mb-6">
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="credit"
                      checked={formData.paymentMethod === 'credit'}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    <span className="flex items-center">
                      <svg className="w-8 h-6 mr-2" viewBox="0 0 32 20" fill="none">
                        <rect width="32" height="20" rx="2" fill="#1A1F36"/>
                        <path d="M12 14L14 6H16L14 14H12Z" fill="white"/>
                        <path d="M20 6C19.5 6 19.1 6.1 18.7 6.2C18.3 6.3 18 6.5 17.8 6.7C17.6 6.9 17.5 7.2 17.4 7.5C17.3 7.8 17.2 8.1 17.2 8.4H19.2C19.2 8.1 19.3 7.9 19.5 7.7C19.7 7.5 19.9 7.4 20.2 7.4C20.5 7.4 20.7 7.5 20.9 7.7C21.1 7.9 21.2 8.2 21.2 8.5C21.2 8.8 21.1 9.1 20.9 9.3C20.7 9.5 20.4 9.7 20 9.8V10C19.5 10.1 19.1 10.2 18.7 10.3C18.3 10.4 18 10.6 17.8 10.8C17.6 11 17.5 11.3 17.4 11.6C17.3 11.9 17.2 12.2 17.2 12.5C17.2 12.8 17.3 13.1 17.5 13.3C17.7 13.5 18 13.7 18.3 13.8C18.6 13.9 19 14 19.4 14H20V13.8H19.4C19.1 13.8 18.9 13.7 18.7 13.6C18.5 13.5 18.4 13.3 18.4 13C18.4 12.7 18.5 12.5 18.7 12.3C18.9 12.1 19.2 12 19.5 12H21V13.8H22.3C22.8 13.8 23.2 13.7 23.6 13.6C24 13.5 24.3 13.3 24.5 13.1C24.7 12.9 24.8 12.6 24.9 12.3C25 12 25 11.7 25 11.4C25 11.1 24.9 10.8 24.7 10.6C24.5 10.4 24.2 10.2 23.8 10.1L23.5 10C23.9 9.8 24.2 9.5 24.4 9.2C24.6 8.9 24.7 8.6 24.7 8.2C24.7 7.8 24.6 7.5 24.3 7.2C24.1 6.9 23.7 6.7 23.3 6.6C22.9 6.5 22.4 6.4 21.9 6.4H20V6.6H21.6C22 6.6 22.3 6.7 22.6 6.8C22.9 6.9 23.1 7.1 23.2 7.3C23.3 7.5 23.4 7.8 23.4 8.1C23.4 8.4 23.3 8.7 23.1 8.9C22.9 9.1 22.6 9.3 22.3 9.4V9.2C22.6 9 22.9 8.7 23 8.4C23.1 8.1 23.2 7.8 23.2 7.4C23.2 7 23.1 6.7 22.8 6.5C22.6 6.3 22.2 6.2 21.8 6.2C21.4 6.2 21 6.3 20.7 6.5C20.4 6.7 20.2 6.9 20.1 7.2H19.2C19.3 6.9 19.5 6.7 19.8 6.5C20.1 6.3 20.5 6.2 20.9 6.1L20 6Z" fill="white"/>
                      </svg>
                      Credit Card
                    </span>
                  </label>
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="paypal"
                      checked={formData.paymentMethod === 'paypal'}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    <span className="flex items-center">
                      <svg className="w-8 h-6 mr-2" viewBox="0 0 100 32" fill="none">
                        <path d="M12.5 3H8L5 28H9L10.5 18H14L18 28H22L18.5 3H14L12.5 3Z" fill="#003087"/>
                        <path d="M38.5 3H34L31 28H35L36.5 18H40L44 28H48L44.5 3H40L38.5 3Z" fill="#003087"/>
                        <path d="M56 3L53.5 22H59L61.5 3H57L56 10H55L54 3H56ZM63 3L60.5 22H66L68.5 3H64L63 10H62L61 3H63Z" fill="#003087"/>
                      </svg>
                      PayPal
                    </span>
                  </label>
                  <label className="flex items-center cursor-pointer">
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="bank"
                      checked={formData.paymentMethod === 'bank'}
                      onChange={handleChange}
                      className="mr-2"
                    />
                    <span className="flex items-center">
                      <svg className="w-8 h-6 mr-2" viewBox="0 0 24 24" fill="currentColor">
                        <path d="M4 10V19H20V10H4ZM3 8H21C21.55 8 22 8.45 22 9V20C22 20.55 21.55 21 21 21H3C2.45 21 2 20.55 2 20V9C2 8.45 2.45 8 3 8ZM6 12H8V14H6V12ZM6 16H8V18H6V16ZM10 12H14V14H10V12ZM10 16H14V18H10V16Z"/>
                      </svg>
                      Bank Transfer
                    </span>
                  </label>
                </div>

                {/* Credit Card Fields */}
                {formData.paymentMethod === 'credit' && (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <div className="md:col-span-2">
                      <label htmlFor="cardName" className="block text-gray-700 font-medium mb-2">Name on Card *</label>
                      <input
                        type="text"
                        id="cardName"
                        name="cardName"
                        value={formData.cardName}
                        onChange={handleChange}
                        required={formData.paymentMethod === 'credit'}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                        placeholder="John Doe"
                      />
                    </div>
                    <div className="md:col-span-2">
                      <label htmlFor="cardNumber" className="block text-gray-700 font-medium mb-2">Card Number *</label>
                      <input
                        type="text"
                        id="cardNumber"
                        name="cardNumber"
                        value={formData.cardNumber}
                        onChange={handleChange}
                        required={formData.paymentMethod === 'credit'}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                        placeholder="1234 5678 9012 3456"
                        maxLength="19"
                      />
                    </div>
                    <div>
                      <label htmlFor="expiryDate" className="block text-gray-700 font-medium mb-2">Expiry Date *</label>
                      <input
                        type="text"
                        id="expiryDate"
                        name="expiryDate"
                        value={formData.expiryDate}
                        onChange={handleChange}
                        required={formData.paymentMethod === 'credit'}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                        placeholder="MM/YY"
                        maxLength="5"
                      />
                    </div>
                    <div>
                      <label htmlFor="cvv" className="block text-gray-700 font-medium mb-2">CVV *</label>
                      <input
                        type="text"
                        id="cvv"
                        name="cvv"
                        value={formData.cvv}
                        onChange={handleChange}
                        required={formData.paymentMethod === 'credit'}
                        className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-gray-500"
                        placeholder="123"
                        maxLength="4"
                      />
                    </div>
                  </div>
                )}

                {formData.paymentMethod === 'paypal' && (
                  <div className="bg-blue-50 p-4 rounded-lg">
                    <p className="text-blue-800">
                      You will be redirected to PayPal to complete your donation securely.
                    </p>
                  </div>
                )}

                {formData.paymentMethod === 'bank' && (
                  <div className="bg-gray-100 p-4 rounded-lg">
                    <p className="text-gray-700">
                      <strong>Bank Transfer Details:</strong><br />
                      Bank Name: Shehala Bank<br />
                      Account Number: 1234567890<br />
                      Routing Number: 987654321<br />
                      SWIFT Code: SHEHALAXXX
                    </p>
                  </div>
                )}
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className="w-full bg-gray-800 text-white py-4 rounded-lg font-semibold text-lg hover:bg-gray-700 transition duration-300"
              >
                {isMonthly ? 'Start Monthly Donation' : 'Donate Now'}
              </button>

              {/* Security Note */}
              <p className="text-gray-500 text-sm text-center mt-4">
                <svg className="w-4 h-4 inline-block mr-1" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"/>
                </svg>
                Your donation is secure and encrypted
              </p>
            </form>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-gray-800 text-white py-8">
        <div className="container mx-auto px-4 text-center">
          <p className="opacity-80">
            © {new Date().getFullYear()} Shehala Foundation. All rights reserved.
          </p>
          <p className="opacity-60 text-sm mt-2">
            A Compassion-Driven Approach to Corporate Social Responsibility
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Donate
